import React, { ReactElement } from "react"
import { camelCase } from "../../../utils"
import BgColor, { HarviaBackgroundColor } from "../../layouts/BgColor"
import * as styles from "./MediaTextBlock.module.scss"

export type MediaTextBlockProps = {
  content: ReactElement
  media?: ReactElement | null
  layout?: MediaTextBlockLayout | null
  contentBackground?: HarviaBackgroundColor | null
  id?: string
}

export type MediaTextBlockLayout = "Tile" | "TextLeft" | "TextRight" | "TextLeftHalf" | "TextRightHalf"

const MediaTextBlock = (props: MediaTextBlockProps) => {
  //console.log("Rendering MediaTextBlock", props)

  const bg = props.contentBackground || "BrandWhite"
  const isBgMedia = camelCase(bg) === "Transparent" || camelCase(bg) === "SemiTransparent"

  const layout = props.layout || "Tile"

  return (
    <BgColor
      color={bg}
      id={props.id}
      className={`${styles.container} ${styles[`layout${layout}`]} ${isBgMedia ? styles.bgMedia : ""}`}>
      <div className={`${styles.mediaArea}`}>{props.media}</div>
      <BgColor color={bg} className={`${styles.contentArea}`}>
        <div className={`layout-container ${styles.content}`}>{props.content}</div>
      </BgColor>
    </BgColor>
  )
}

export default MediaTextBlock
